import {
  IActionType,
  ICreateNewsfeedPayload,
  IFetchPromoActionResponse,
  IGetQueryParams,
} from "../../interfaces/Index";
import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  createNewsfeedApiCall,
  fetchNewsfeedListApiCall,
  updateNewsfeedApiCall,
} from "../sources/NewsfeedSource";

export const fetchNewsfeedListInit = () => ({
  type: actionTypes.GET_NEWSFEED_LIST_INIT,
});

export const fetchNewsfeedListSuccess = (
  payload: IFetchPromoActionResponse | null
) => ({
  type: actionTypes.GET_NEWSFEED_LIST_SUCCESS,
  payload,
});

export const fetchNewsfeedListFail = (error: string | object | null) => ({
  type: actionTypes.GET_NEWSFEED_LIST_FAIL,
  error,
});

export const createNewsfeedInit = () => ({
  type: actionTypes.CREATE_NEWSFEED_INIT,
});

export const createNewsfeedSuccess = () => ({
  type: actionTypes.CREATE_NEWSFEED_SUCCESS,
});

export const createNewsfeedFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_NEWSFEED_FAIL,
  error,
});

export const updateNewsfeedInit = () => ({
  type: actionTypes.UPDATE_NEWSFEED_INIT,
});

export const updateNewsfeedSuccess = () => ({
  type: actionTypes.UPDATE_NEWSFEED_SUCCESS,
});

export const updateNewsfeedFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_NEWSFEED_FAIL,
  error,
});

export const getNewsfeedListAction =
  (queryParams?: IGetQueryParams) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchNewsfeedListInit());
    return fetchNewsfeedListApiCall(queryParams)
      .then((newsfeeds: any) => {
        dispatch(fetchNewsfeedListSuccess(newsfeeds));
      })
      .catch((e: object | null | string) => dispatch(fetchNewsfeedListFail(e)));
  };

export const createNewsfeedAction =
  (payload: ICreateNewsfeedPayload) => (dispatch: Dispatch<IActionType>) => {
    dispatch(createNewsfeedInit());
    return createNewsfeedApiCall(payload)
      .then(() => dispatch(createNewsfeedSuccess()))
      .catch((e: object | null | string) => dispatch(createNewsfeedFail(e)));
  };

export const updateNewsfeedAction =
  (id: string, payload: ICreateNewsfeedPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(updateNewsfeedInit());
    return updateNewsfeedApiCall(id, payload)
      .then(() => dispatch(updateNewsfeedSuccess()))
      .catch((e: object | null | string) => dispatch(updateNewsfeedFail(e)));
  };
